import { useTranslation } from 'react-i18next';
import logo from '../assets/logo-new.png';

export function Footer() {
  const { t } = useTranslation();
  const currentYear = new Date().getFullYear();

  return (
    <footer className="mt-auto border-t border-slate-200 bg-white px-4 py-4 sm:px-6 lg:px-8">
      <div className="mx-auto flex w-full max-w-screen-xl flex-col items-center justify-center gap-3 text-center">
        <img
          src={logo}
          alt="Investe Sempre"
          className="h-auto w-20 max-w-full opacity-60"
        />
        <p className="m-0 max-w-full text-center text-xs leading-relaxed text-slate-500 break-words">
          © {currentYear} Investe Sempre. {t('allRightsReserved')}
        </p>
      </div>
    </footer>
  );
}
